/*
  Add.jsx
*/

import React from 'react';
import SvgIcon from '../components/SvgIcon';

export default function Add(props) {
  return (
    <SvgIcon {...props}>
      <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"></path>
    </SvgIcon>
  );
}
